export default class TrendChart {

    constructor( chartId ) {
      this.chartId = chartId;

        this.config = {
            animate : true,
            animationDuration : 1500 , 
            svg: { bg: 'white', h: null, w: null  },
            plotArea : { bg: 'white' },
            point : { r: 7 , color: '#6d1f37' },
            line: { width: 4 , color: '#6d1f37' },
            axis: {
                x: { 
                    h : 40, 
                    line: { show: true, color: '#a9a9a9', width : 2,    },
                    title: { show:true,  text: 'Period', height: 5, },
                    cats : {
                        ticks: {
                            show: true,
                            color: '#a9a9a9',
                            length: 10,
                        },
                        label: {
                            show: true,
                            color: '#101820',
                            size: '14px',
                        },
                        gridLines : {
                            show: true,
                            color: 'orange'
                        }
                    }
                },
                y: { 
                    w : 40, 
                    min: 0 , 
                    max: 100,
                    title: {
                        show:true,
                        text: '%',
                        w: 5,
                    },
                    line: {
                        show: true,
                        color: 'none',
                        width: 2,
                    },
                    cats : {
                        interval: 25,
                        start: 0,
                        ticks: { //small tick line
                            show: true,
                            color: 'none',
                            length: 5,
                        },
                        label: { //label next to each tick
                            show: true,
                            color: '#101820',
                            size: '14px',
                            format: ".0%",
                        },
                        gridLines : { //horiz lines
                            show: true,
                            color: 'lightgray',
                            width: 1,
                        },
                        bands:{ //zebra banding
                            show: true,
                            color: 'none',
                        }
                    }
                },
            },
            padding : [ 15, 0, 0, 0 ],
            plot: {}
        };

        this.data = {
            cats: [],
            data : []
        };

        //this.createElements();
      //console.log( 'construct')
    }

    /**
     * render()
     * Renders all svg elements
     * No sizes or positions are specified
     * that is controlled in draw and scale functions
     */
    render(){
        let self = this;
        //get the svg
		let div = d3.select( this.chartId );
        let svg = div.append("svg").style( 'background', self.config.svg.bg );

		//tooltip div
		// create a tooltip after the svg so it sits on top
		self.tooltip = div
				.append("div")
				.attr('class', 'chart-tooltip')
				.style("position", "absolute")
				.style("visibility", "hidden")
				.text("");
        svg.append("rect")
            .attr('class', 'rect-plot' )
            .attr( 'fill', self.config.plotArea.bg );

        self.config.catCount = self.data.cats.length;

        var yCatData = [];
		for( let i = self.config.axis.y.cats.start ; i >=  self.config.axis.y.min ; i-=  self.config.axis.y.cats.interval ){
			yCatData.push(  i  );
		}
		for( let i =  self.config.axis.y.cats.start ; i <=  self.config.axis.y.max ; i+=  self.config.axis.y.cats.interval ){
			yCatData.push(  i  );
		}
        yCatData = Array.from(new Set(yCatData)) ;
        
        var yAxisGroup = svg.append('g')
							.attr('class', 'group-axis-y');
						
		var yBandsGroup = yAxisGroup.append('g').attr('class', 'axis-y-group-bands' );

		//FOR BANDS WE NEED AN EXTRA ONE
        var maxCat = Math.max(...yCatData);
        
        var yBandData = [ ...yCatData , maxCat +  self.config.axis.y.cats.interval ] ;
        
		yBandsGroup.selectAll('rect')
            .data( yBandData )
            .enter()
            .append('rect')
            .attr('class', 'axis-y-band')
            .style("fill", function( d ){
                if( ( d /  self.config.axis.y.cats.interval ) & 1 ){
                    return "none";
                }
                return  self.config.axis.y.cats.bands.color 
            });

		yAxisGroup.append('line')
            .attr('class', 'axis-y-line')
            .style("stroke",  self.config.axis.y.line.color )
            .attr("stroke-width",  self.config.axis.y.line.width ); 

		var yAxisTickGroup = yAxisGroup.append('g').attr('class', 'group-axis-y-ticks');

		yAxisTickGroup.selectAll('line')
            .data( yCatData )
            .enter()
            .append('line')
            .attr('class', 'axis-y-tick')
            .style("stroke",  self.config.axis.y.cats.ticks.color )
            .attr("stroke-width",  self.config.axis.y.line.width );

        var catGroup = yAxisGroup.append('g').attr('class', 'axis-y-group-cats' );
        
        catGroup.selectAll('text')
			.data( yCatData )
			.enter()
			.append( 'text' )
			.attr('class', 'yaxis-label' )
			.text( function (d) { return d3.format(  self.config.axis.y.cats.label.format )(d*0.01) ; }) 
			.attr("text-anchor", "end")
			.attr("dominant-baseline", "central")
			.attr("font-size",  self.config.axis.y.cats.label.size )
			.attr("fill",  self.config.axis.y.cats.label.color );

		var gridLineGroup = yAxisGroup.append('g').attr('class', 'axis-y-group-gridlines' );

		gridLineGroup.selectAll('line')
            .data( yCatData )
            .enter()
            .append('line')
            .attr('class', 'axis-y-gridline')
            .style("stroke",  self.config.axis.y.cats.gridLines.color )
            .attr("stroke-width",  self.config.axis.y.cats.gridLines.width );

		var xAxisGroup = svg.append('g').attr('class', 'group-axis-x');
		xAxisGroup.append('line')
            .attr('class', 'axis-x-line')
            .style("stroke",  self.config.axis.x.line.color )
            .attr("stroke-width",  self.config.axis.x.line.width ); 

        var xAxisTickGroup = xAxisGroup.append('g').attr('class', 'group-axis-x-ticks');
        
        xAxisTickGroup.selectAll('line')
            .data( self.data.cats )
            .enter()
            .append('line')
            .attr('class', 'axis-x-tick')
            .style("stroke",  self.config.axis.x.cats.ticks.color )
            .attr("stroke-width",  self.config.axis.x.line.width ); 
		

		var catGroup = xAxisGroup.append('g').attr('class', 'axis-x-group-cats' );

		catGroup.selectAll('text')
            .data( self.data.cats )
            .enter()
            .append( 'text' )
            .attr('class', 'xaxis-label' );



		var plotLineGroup = svg.append('g').attr('class', 'group-data-line' );
		var lineGraph = plotLineGroup.append("path")
						.attr('class', 'plot-line' )
						.attr('data-data', JSON.stringify(self.data.data) )
						.attr("stroke",  self.config.line.color )
						.attr("stroke-width",  self.config.line.width )
						.attr("pathLength", 1 )
						.attr("fill", "none");


		lineGraph
			//.attr("stroke-dasharray", totalLength + " " + totalLength)
			.attr("stroke-dashoffset", 1)
			.attr("stroke-dasharray", 1)
			.transition()
				.duration(  self.config.animationDuration )
				.ease(d3.easeLinear)
				.attr("stroke-dashoffset", 0);


		var seriesGroup = svg.append('g').attr('class', 'group-data-points' );

		seriesGroup.selectAll('circle')
            .data( self.data.data )
            .enter()
            .append( 'circle' )
            .attr('class', 'plot-point' )
            .transition()
            .delay( function ( d, i ){
                return i /  self.config.catCount  *  self.config.animationDuration * 0.75 ; //0.75 so comes in when line finishes
            })
            .duration(  self.config.animationDuration )
            .attr( 'r',  self.config.point.r )
            .style( 'fill' ,  self.config.point.color );

        self.scalePlot();
    }


    scalePlot(  ){
        let self = this;
        
		var div = d3.select( this.chartId );
		var svg = div.select('svg');
		self.tooltip = d3.select( this.chartId + ' .chart-tooltip');
		//set its default props
		svg.attr( 'width' ,  '100%' ).attr( 'height' ,  '300px' ); //set to full width
		//TODO: do we need to set the heigh too? maybe work on a widescreen ratio? and a minimum pixel too
		//det dimensions to save forever
		self.config.svg.w = svg.style('width').replace("px", "");
		self.config.svg.h = svg.style('height').replace("px", "");

		//get plot H and W to save for later
		self.config.plot.w = self.config.svg.w - self.config.axis.y.w - self.config.padding[1] - self.config.padding[3];
		self.config.plot.h = self.config.svg.h - self.config.axis.x.h - self.config.padding[0] - self.config.padding[2];
		self.config.plot.x = self.config.axis.y.w + self.config.padding[ 3 ];
		self.config.plot.y = self.config.padding[ 0 ];
		self.config.plot.x1 = self.config.plot.x + self.config.plot.w ;
		self.config.plot.y1 = self.config.plot.y + self.config.plot.h;

        //console.log("scalePlot -> config", self.config)


		var catCnt = svg.selectAll('.xaxis-label').size();
		var catScale = d3.scaleLinear()
						.domain([ -0.5, catCnt - 0.5 ])
						.range([ self.config.plot.x , self.config.plot.x1   ]);
		var scoreScale = d3.scaleLinear()
						.domain([ self.config.axis.y.min , self.config.axis.y.max ])
						.range([ self.config.plot.y1 , self.config.plot.y   ]);

		var lineFunction = d3.line()
                          .x(function(d , i ) { return catScale( d.x ) ; })
                          .y(function(d) { return scoreScale( d.y ) ; })
						  .curve(d3.curveCardinal);

		svg.select('.rect-plot')
				.attr( 'width' , self.config.plot.w )
				.attr( 'height' , self.config.plot.h  )
				.attr( 'x' , self.config.plot.x )
				.attr( 'y' , self.config.plot.y  );
		
		svg.select('.axis-y-line')
				.attr("x1", self.config.plot.x )     
				.attr("y1", self.config.plot.y )      
				.attr("x2", self.config.plot.x )    
				.attr("y2",  self.config.plot.y1 );    
		
		svg.select('.axis-x-line')
				.attr("x1", self.config.plot.x )     
				.attr("y1", self.config.plot.y1 )      
				.attr("x2", self.config.plot.x1 )    
				.attr("y2",  self.config.plot.y1 ); 

		//move data points
		svg.selectAll('circle.plot-point')
			.on("mouseover", function( event , d ){
				let point = d3.select(this);
				point.transition()
					.duration(250)
					.ease(d3.easeBackOut.overshoot(5))
					.attr("r",  self.config.point.r * 1.5 );

				

				//console.log( point.data() );
				//console.log( d );

				self.tooltip.text( parseFloat(d.y).toFixed(1)+'% (n='+d.cnt+')' );

				self.tooltip.style("visibility", "visible");

				let w =  self.tooltip.node().getBoundingClientRect().width ;
				let h =  self.tooltip.node().getBoundingClientRect().height ;
				let margin = 30;


				self.tooltip.style("top", (point.attr('cy') - h - margin )+"px").style("left",(point.attr( 'cx' ) - w/2  )+"px");
			})
			.on("mouseout", function(){
				self.tooltip.style("visibility", "hidden");

				d3.select(this).transition()
					.duration(250)
					.attr("r",  self.config.point.r  );
				
			})
			.attr( 'cx' , function( d, i  ){
				return catScale( d.x );
			})
			.attr( 'cy' , function( d, i  ){
				return scoreScale( d.y );
			});

		
		svg.selectAll('text.xaxis-label')
			.attr( 'x' , function( d, i  ){
				return catScale( i );
			})
			.attr( 'y' , self.config.plot.y1 + 25 )
			.text( function (d) { 
                //console.log("d", d)
				return d; 
			}) 
			.attr("text-anchor", "middle")
			.attr("font-size", self.config.axis.x.cats.label.size )
			.attr("fill", self.config.axis.x.cats.label.color );

		svg.selectAll('.axis-x-tick')
			.attr( 'x1' , function( d, i  ){
				return catScale( i );
			})
			.attr( 'y1' , self.config.plot.y1  )
			.attr( 'x2' , function( d, i  ){
				return catScale( i );
			})
			.attr( 'y2' , self.config.plot.y1 + self.config.axis.x.cats.ticks.length   );

		svg.selectAll('.axis-y-tick')
			.attr( 'x1' , self.config.plot.x - self.config.axis.y.cats.ticks.length )
			.attr( 'y1' , function( d ){ return scoreScale( d ) } )
			.attr( 'x2' , self.config.plot.x   )
			.attr( 'y2' , function( d ){ return scoreScale( d ) }  );

		svg.selectAll('text.yaxis-label')
			.attr( 'x' , self.config.plot.x - self.config.axis.y.cats.ticks.length - 5 )
			.attr( 'y' , function( d ){ return scoreScale( d ) } );	

		svg.selectAll('.axis-y-gridline')
			.attr( 'x1' , self.config.plot.x  )
			.attr( 'y1' , function( d ){ return scoreScale( d ) } )
			.attr( 'x2' , self.config.plot.x1   )
			.attr( 'y2' , function( d ){ return scoreScale( d ) }  );

		svg.selectAll('.axis-y-band')
			.attr( 'x' , self.config.plot.x  )
			.attr( 'y' , function( d ){ return scoreScale( d ) } )
			.attr( 'width' , self.config.plot.w   )
			.attr( 'height' , function( d ){ 
				var lowerBand = d - self.config.axis.y.cats.interval;
				if( lowerBand < self.config.axis.y.min ){
					lowerBand = self.config.axis.y.min
				}
				return scoreScale( lowerBand )  - scoreScale( d )    
				
			}  );

		var data = JSON.parse( svg.select('.plot-line').attr('data-data') );
		svg.select('.plot-line').attr("d", lineFunction( data ));

		
    }
    

    redraw(  ){
        let self = this;
		var div = d3.select( this.chartId );
		var svg = div.select('svg');

		//data points
		var pointsGroup = svg.select('.group-data-points').selectAll('.plot-point')
			.data( self.data.data );
		pointsGroup.enter()
			.append('circle')
			.attr('class' , 'plot-point');

		pointsGroup.exit().remove();
		
		//add redraw animations only
		svg.selectAll('.plot-point')
			.attr("r",  0  )
			.transition()
			.delay( function ( d, i ){
				return i / self.data.data.length  * self.config.animationDuration * 0.75 ; //0.75 so comes in when line finishes
			})
			.duration( self.config.animationDuration )
			.attr( 'r', self.config.point.r )
			.style( 'fill' , self.config.point.color );

		var xGroupLabels = svg.select('.axis-x-group-cats').selectAll('.xaxis-label')
			.data( self.data.cats );
		xGroupLabels.enter()
			.append('text')
			.attr('class' , 'xaxis-label');
		xGroupLabels.exit().remove();

		var xGroupTicks = svg.select('.group-axis-x-ticks').selectAll('.axis-x-tick')
			.data( self.data.cats );
		xGroupTicks.enter()
			.append('line')
			.attr('class' , 'axis-x-tick');

		xGroupTicks.exit().remove();
		
		
		svg.select('.plot-line')
			.attr("data-data", JSON.stringify( self.data.data ))
			.attr("stroke-dashoffset", 1)
			.attr("stroke-dasharray", 1)
			.transition()
				.duration( self.config.animationDuration )
				.ease(d3.easeLinear)
				.attr("stroke-dashoffset", 0);

        self.scalePlot(  );
	}


}